import { createFileRoute } from "@tanstack/react-router";
import AdminSecurityReport from "@/pages/AdminSecurityReport";

export const Route = createFileRoute("/admin/security/report/")({
  component: AdminSecurityReport,
});
